// pages/ReportView/ReportViewPage.tsx
import React from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import {
  Download,
  Print,
} from '@mui/icons-material';

const ReportViewPage: React.FC = () => {
  const { reportId, objectId } = useParams<{ reportId: string; objectId?: string }>();

  // Mock report data
  const reportData = {
    id: parseInt(reportId || '1'),
    name: 'Raport dobowy - Kontrola jakości',
    generatedAt: new Date().toLocaleString('pl-PL'),
    data: [
      { time: '08:00', temperature: 22.5, status: 'OK', operator: 'Jan Kowalski' },
      { time: '10:00', temperature: 23.1, status: 'OK', operator: 'Anna Nowak' },
      { time: '12:00', temperature: 24.0, status: 'Ostrzeżenie', operator: 'Jan Kowalski' },
      { time: '14:00', temperature: 22.8, status: 'OK', operator: 'Piotr Wiśniewski' },
      { time: '16:00', temperature: 22.2, status: 'OK', operator: 'Anna Nowak' },
    ],
  };

  const handleExport = (format: 'pdf' | 'excel') => {
    console.log(`Export report as ${format}`);
    // Tutaj będzie logika eksportu
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
        <Box>
          <Typography variant="h4" gutterBottom>
            {reportData.name}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Wygenerowano: {reportData.generatedAt}
          </Typography>
          {objectId && (
            <Typography variant="subtitle2" color="text.secondary">
              Obiekt: {objectId}
            </Typography>
          )}
        </Box>

        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            startIcon={<Print />}
            onClick={handlePrint}
          >
            Drukuj
          </Button>
          <Button
            variant="outlined"
            startIcon={<Download />}
            onClick={() => handleExport('pdf')}
          >
            PDF
          </Button>
          <Button
            variant="outlined"
            startIcon={<Download />}
            onClick={() => handleExport('excel')}
          >
            Excel
          </Button>
        </Box>
      </Box>

      <Card>
        <CardContent>
          <TableContainer component={Paper} variant="outlined">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Czas</TableCell>
                  <TableCell>Temperatura (°C)</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Operator</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reportData.data.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.time}</TableCell>
                    <TableCell>{row.temperature}</TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          color: row.status === 'OK' ? 'success.main' : 'warning.main',
                          fontWeight: 'bold',
                        }}
                      >
                        {row.status}
                      </Box>
                    </TableCell>
                    <TableCell>{row.operator}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReportViewPage;